import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link as RouterLink, } from "react-router-dom";
// From https://mui.com/material-ui/guides/routing/#global-theme-link
export const LinkBehavior = React.forwardRef(function Link(props, ref) {
    const { href, ...other } = props;
    // Map href (Material UI) -> to (react-router)
    return _jsx(RouterLink, { ref: ref, to: href, ...other });
});
